import { render, staticRenderFns } from "./MKalender.vue?vue&type=template&id=0b196197"
import script from "./MKalender.vue?vue&type=script&lang=js"
export * from "./MKalender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports